// from https://github.com/sandstrom/country-bounding-boxes/blob/master/bounding-boxes.json
import type { Region, SupportedCountryCode } from "./types";

export const supportedCountries: Record<SupportedCountryCode, Region> = {
    AT: {
        bounds: [9.48, 46.43, 17.2, 49.04],
    },
    BE: {
        bounds: [2.51, 49.53, 6.16, 51.48],
    },
    CH: {
        bounds: [6.02, 45.78, 10.44, 47.83],
    },
    CZ: {
        bounds: [12.24, 48.56, 18.85, 51.12],
    },
    DK: {
        bounds: [8.09, 54.8, 12.69, 57.73],
    },
    DE: {
        bounds: [5.99, 47.3, 15.02, 54.98],
    },
    ES: {
        bounds: [-9.39, 35.95, 3.04, 43.75],
    },
    FR: {
        bounds: [-5.0, 42.5, 9.56, 51.15],
    },
    GB: {
        bounds: [-7.57, 49.96, 1.68, 58.64],
    },
    HU: {
        bounds: [16.2, 45.76, 22.71, 48.62],
    },
    IT: {
        bounds: [6.75, 36.62, 18.48, 47.12],
    },
    NL: {
        bounds: [3.31, 50.8, 7.09, 53.51],
    },
    PL: {
        bounds: [14.07, 49.03, 24.03, 54.85],
    },
    PT: {
        bounds: [-9.53, 36.84, -6.39, 42.28],
    },
    RO: {
        bounds: [20.22, 43.69, 29.63, 48.22],
    },
    SK: {
        bounds: [16.88, 47.76, 22.56, 49.57],
    },
    SE: {
        bounds: [11.03, 55.36, 23.9, 69.11],
    },
    US: {
        bounds: [-125.0, 25.0, -66.96, 49.5],
    },
};

export function isCountryCodeSupported(
    codeToTest: string,
): codeToTest is SupportedCountryCode {
    return codeToTest in supportedCountries;
}

export const EU_REGION: Region = { bounds: [-25, 34, 43, 72] };

// whole europe is fallback region
export const FALLBACK_REGION: Region = EU_REGION;
